import * as StoreUtil from '../util/InClientStoreUtil';
import DisableAppRequest from 'owa-service/lib/contract/DisableAppRequest';
import DisableExtensionJsonRequest from 'owa-service/lib/contract/DisableExtensionJsonRequest';
import DisableExtensionJsonRequestFactory from 'owa-service/lib/factory/disableExtensionJsonRequest';
import DisableExtensionJsonResponse from 'owa-service/lib/contract/DisableExtensionJsonResponse';
import DisableExtensionOperation from 'owa-service/lib/operation/disableExtensionOperation';
import { createOverrideOptions } from '../util/InClientStoreHelper';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'DisableOutlookWebExt',
        (data: any, responseMethod: Function) => {
            DisableOutlookWebExt(data).then(response => {
                if (response.Body.ResponseClass.toString() == 'Error') {
                    responseMethod(
                        [
                            response.Body.MessageText.toString(),
                            response.Body.ResponseCode.toString(),
                        ],
                        -1
                    );
                } else {
                    responseMethod([data.toString()], 0);
                }
                StoreUtil.updateAddinSurface();
            });
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}

function DisableOutlookWebExt(data: any): Promise<DisableExtensionJsonResponse> {
    const Body: DisableAppRequest = {
        __type: 'DisableAppRequest:#Exchange',
        ID: data.toString(),
        DisableReason: 'NoReason',
    };
    const DisableRequest: DisableExtensionJsonRequest = {
        Header: getJsonRequestHeader(StoreUtil.getUserTimeZone()),
        Body: Body,
    };

    const params: DisableExtensionJsonRequest = DisableExtensionJsonRequestFactory(DisableRequest);
    const fetchOptions = createOverrideOptions();

    return DisableExtensionOperation(params, fetchOptions);
}
